import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';
import { NgxPrinterModule } from 'ngx-printer';

import { CoreModule } from '../../../core/core.module';
import { EncouragementCardModule } from '../encouragement-card/encouragement-card.module';
import { DiaryComponent } from './diary/diary.component';
import { DiaryCardModule } from './diary-card/diary-card.module';
import { DiaryDayColumnComponent } from './diary-day-column/diary-day-column.component';
import { DiaryPicturePreviewModalModule } from './diary-picture-preview-modal/diary-picture-preview-modal.module';
import { DiaryPrintModalComponent } from './diary-print-modal/diary-print-modal.component';

@NgModule({
  declarations: [
    DiaryDayColumnComponent,
    DiaryComponent,
    DiaryPrintModalComponent,
  ],
  exports: [DiaryDayColumnComponent, DiaryComponent, DiaryPrintModalComponent],
  imports: [
    CommonModule,
    EncouragementCardModule,
    CarouselModule,
    NgxBootstrapIconsModule,
    NgxInnerLoadingModule,
    NgxPrinterModule,
    DiaryCardModule,
    DiaryPicturePreviewModalModule,
    ReactiveFormsModule,
    CoreModule,
    FormsModule,
  ],
})
export class DiaryModule {}
